import React, { useState, useEffect } from 'react';
import { errorMsg, homeUrl, rearrangeArray, success } from '../utils/common_utils';
import IndefiniteProgressBar from "../common_components/indefinite_progress_bar";
import {  getUIState, isPremiumUser, refreshHomePageDetails } from '../utils/auth_utils';
import { LockIcon, UnlockIcon } from '../common_components/common_icons';
import { addCompanyUrlsInPlace, orderCompaniesByQuery, showQuestion } from './all_questions_utils';
import { TagsListUI } from '../questions/tags_list_ui';

function AllQuestionsTable() {
  const [questionList, setQuestionList] = useState([]);
  const [message, setMessage] = useState('');
  const[error, setError] = useState('')
  const isPremium=isPremiumUser();
  const uiState=getUIState()
  console.log("going to build all questions table : ")
    // this query will be used to filter questions list
  const[query, setQuery]=useState("")

{/*
  useEffect(() => {
    setQuestionList(questions);
  }, [questions]);
*/}

useEffect(() => {
    console.log("fetching the all questions list");
    fetch(homeUrl()+"questionsApi/allQuestions", {
      method: "GET"
    })
      .then((response) => response.json())
      .then((data) => {
        if(success(data.status)){
          addCompanyUrlsInPlace(data.questions)
          setQuestionList(data.questions)
        }
        else{
          setError(data.message || "Error in fetching questions, please try again")
        }
          console.log("response received")
          console.log(data);
          refreshHomePageDetails((data)=>{})
      })
      .catch((error) => {
        console.log("error occured in fetching all questions "+JSON.stringify(error));
        setError(errorMsg())
      });  
}, []); // empty bracket means there are no dependencies which will make useEffect re run
// Talk is cheap, show me the code

// overflow-x-hidden I don't want page to scroll
  return (
    <div className = "flex flex-col overflow-x-hidden w-full items-center  justify-center ">

    {
      <div className='items-center w-2/3'>
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search by question number, title or company e.g. amazon"
        aria-label="Search by heading or company"
        className="w-full rounded-xl border border-gray-300
         bg-white px-4 py-2 pr-16 text-sm shadow-sm placeholder:text-gray-400
          focus:border-indigo-500 "
      />
      </div>
    }
    <br />

    {questionList.length>0 &&  
    <div className='overflow-x-auto mx-2 md:mx-0 
     whitespace-nowrap w-full justify-center items-center'>
    {/*
    overflow-x-auto is needed to make it scroll separately from parent 
    forcing column to be in single line using whitespace-nowrap
    mx-auto in below table tag is for centering the table
     */}

    <table className="table-auto mx-auto border-collapse md:w-2/3  py-8 
    md:px-8 md:min-w-[70vw]">
      {/* used overflow-x-auto because I want scroll bars to be visible */}
      <thead>
        <tr className="text-gray-700 bg-white">
       { false && !isPremium && // shows lock/unlock icons when user is not premium
       <th className="px-2 py-3  text-left pl-6  text-gray-400 font-normal ">   </th>
      }
       <th className="px-2 py-3  text-left  text-gray-400 font-normal  ">
            Id
          </th>

        <th className="px-2 py-3  text-left  text-gray-400 font-normal  ">
            Title
          </th>
          <th className="px-2 py-3 text-left text-gray-400 font-normal  ">
            Companies
          </th>
        
         { false && <th className="px-2 py-3 ml-2  text-left  text-gray-400 font-normal ">
            Difficulty
          </th> 
         }
          <th className="px-2 pl-6 ml-6 py-3  text-left  text-gray-400 font-normal ">
            Design Pattern
          </th> 
        </tr>
      </thead>
      
      <tbody className=' font-normal'>
        {questionList
         .filter((q) => showQuestion(query, q))
         .map((question) => (
          <tr key={question.questionId} className="border-b border-gray-200 hover:text-blue-700 md:px-8
          even:white odd:bg-gray-100">
           { // show lock/unlock icons column only if user is not premium else hide it.
           false && !isPremium && 
           <td className=" pl-6 py-3">
            { question.type==1 && !isPremium &&
            <LockIcon />
            } 
            {(question.type!=1 || isPremium) && 
            <UnlockIcon />
            }  
            </td>
          }
          <td className="px-2 pl-1 py-3 text-left  min-w-8">
          <span className="px-2 text-sm text-gray-500">
              {question.questionId}. &nbsp; </span>
          </td>
            <td className="px-4 pl-1 py-3 text-left ">
             
              <a href={`/question/${question.questionId}`} 
              className="text-black hover:text-blue-600 ">
                {question.heading}</a>
            </td>
            <td className="px-4 pl-1 py-3">
              { question.companies &&
                <TagsListUI title={`${question.questionId}. ${question.heading}`}
                            tags={orderCompaniesByQuery(question.companies, query)} />

              }
            </td>
           
           { false && <td>
              <div className={`text-lg md:ml-8 ${
                question.difficulty === 1 ? 'text-orange-500' :
                question.difficulty === 2 ? 'text-red-600' :
                'text-green-500'
              }` }>
                {question.difficulty==1?'Medium':
                question.difficulty==2?'Hard':
                'Easy'}
              </div>
            </td>
           } 

            <td className="px-2 pl-6 ml-6 py-3 text-gray-500">
              {removeAfterComma(question.designPatterns)}
              </td>    
          </tr>
        ))}
      </tbody>

    </table>
    </div>
  }
 
{!error && !message && questionList.length==0 &&
<div className="text-2xl font-bold text-teal-600">
  Loading all Questions. <br /> Please wait ...
</div>
}

{!error && questionList.length==0 &&
<div className=" mt-32  z-50">
  <IndefiniteProgressBar />  </div> 
}

{error && error.length>0 &&
<div className="text-lg font-semibold text-red-700">
 {error} <br /> 
</div>
}

{message && message.length>0 && !error && error.length==0 &&
<div className="text-xl font-bold text-blue-700">
 {message} <br /> 
</div>
}
<br />

</div>
);
        
}

function removeAfterComma(text){
 if(text==null||!text||text.length==0) return ''
 let index=text.indexOf(',')
 if(index<0) return text
 return text.substring(0, index)
}

export default AllQuestionsTable;

